import {put, take, fork, join} from 'redux-saga/effects';
import searchApi from '../api/search.api';
import * as ActionTypes from '../actions/types.action';

export default function* searchCategoryDescription() {
  while (true) {
    const action = yield take(
      ActionTypes.GET_SEARCH_CATEGORY_DESCRIPTION_REQUESTED
    );
    try {
      if (action.brand) {
        const resultsFork = yield fork(
          searchApi.searchOwnBrandsDescription,
          action.brand
        );
        const results = yield join(resultsFork);
        yield put({
          type: ActionTypes.GET_SEARCH_CATEGORY_DESCRIPTION_SUCCESS,
          description: results.Description,
        });
      }
    } catch (e) {
      yield put({
        type: ActionTypes.GET_SEARCH_CATEGORY_DESCRIPTION_FAILED,
        message: e.message,
      });
    }
  }
}
